module.exports = __webpack_public_path__ + "static/des-8064e57b1bf239669dbcf8723fcc324f.png";